import React, { Component } from 'react';
import { Tabs, Card, Button, Dropdown, Menu } from 'antd';
import { inject, observer } from 'mobx-react';
import { SubscriptionsTable } from './SubscriptionsTable';
const { TabPane } = Tabs;

@inject('store')
@observer
export class SubscriptionsOverviewView extends Component {
    handleMenuClick(e) {
        this.props.history.push(`/a/subscriptions/new?bot_type=${e.key}`);
    }

    render() {
        const menu = (
            <Menu onClick={this.handleMenuClick.bind(this)}>
                <Menu.Item key="apex">Apex (Spot)</Menu.Item>
                <Menu.Item key="mako">Mako (Leverage)</Menu.Item>
            </Menu>
        );
        return (
            <div>
                <Card
                    title="Subscriptions"
                    size="small"
                    extra={
                        <Dropdown overlay={menu}>
                            <Button
                                disabled={!this.props.store.userStore.currentUser.country}
                                type="primary"
                            >
                                New Subscription
                            </Button>
                        </Dropdown>
                    }
                    bordered={false}
                >
                    <SubscriptionsTable />
                </Card>
            </div>
        );
    }
}

// <Tabs defaultActiveKey="1">
//                         <TabPane tab="Subscriptions" key="1">

//                         </TabPane>
//                         {/* <TabPane tab="Invoices" key="2">
//                             <InvoicesTable />
//                         </TabPane> */}
//                     </Tabs>



// WEBPACK FOOTER //
// ./src/Account/SubscriptionsView/OverviewView.js